import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BucketStrategy, toTitleCase } from "@iotv/datamodel-core";
import { Alert, Radio } from "@mui/material";
import { Stack } from "@mui/material";
import { useContext } from "react";
import { StripedDataGrid } from "../../../components/factories/DataGrid";
import { ObservationsContext } from "../Contexts/OvesrvationsContextType_V2";
export const KeyBucketStrategySelector = ({}) => {
    const { state: ObservationContextState, dispatch } = useContext(ObservationsContext);
    const { bucketStrategyMap, selectedKeys, } = ObservationContextState;
    const { APPORTION, INFERREADING, } = BucketStrategy;
    const labels = {
        [APPORTION]: 'Apportion',
        [INFERREADING]: 'Infer Reading',
    };
    const getBucketStrategyRenderer = (bucketStrategy) => ({ row, }) => {
        const isSelected = bucketStrategyMap ? bucketStrategyMap[row.key] === bucketStrategy : false;
        const isDefaulted = !bucketStrategyMap?.[row.key] && bucketStrategy === BucketStrategy.INFERREADING; // this is disconnected currently. If the default is changed it will need revision
        const handleClick = () => {
            const action = { type: 'setBucketingStrategy', value: { [row.key]: bucketStrategy } };
            dispatch(action);
        };
        return (_jsx(Radio, { checked: isSelected || isDefaulted, onChange: handleClick }));
    };
    const columns = [
        { field: 'key', headerName: 'Key', flex: 1, valueFormatter: (value) => toTitleCase(value, { underscoreToSpace: true }) },
        ...Object.entries({ APPORTION, INFERREADING, }).map(([key, value]) => {
            return {
                field: key,
                headerName: labels[value] ?? key,
                flex: 1,
                renderCell: getBucketStrategyRenderer(value)
            };
        })
    ];
    const inferredBucketStrategies = Object.fromEntries((selectedKeys ?? []).values().map((key) => [key, bucketStrategyMap?.[key] ?? BucketStrategy.APPORTION]));
    const rows = Object.entries(inferredBucketStrategies ?? {}).map(([key, value]) => ({ id: key, key, value }));
    const datagridProps = {
        columns,
        rows,
        hideFooter: true,
        autoHeight: true,
    };
    return _jsxs(Stack, { children: [selectedKeys && selectedKeys.length > 0 && (_jsx(Alert, { severity: "info", children: "Select a bucketing strategy for each key. The default is Infer Reading, which averages values in the same time period and infers missing values. Apportion will divide values across buckets based on time." })), _jsx(StripedDataGrid, { ...datagridProps })] });
};
